<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog
    title="添加账号"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="账号" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="真实姓名" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="商家姓名" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="营业执照"
        prop="imageId"
        :label-width="formLabelWidth"
      >
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.imageId != ''" class="img">
            <img :src="filePath" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="代理等级" prop="name" :label-width="formLabelWidth">
        <el-radio-group v-model="form.radio">
          <el-radio :label="1">省代理</el-radio>
          <el-radio :label="2">城市代理</el-radio>
          <el-radio :label="3">区县代理</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择省" :label-width="formLabelWidth">
        <el-select v-model="form.cate_id">
          <!-- <el-option label="顶级分类" value="0"></el-option> -->
          <el-option
            :value="cat.cate_id"
            :label="cat.name"
            :key="cat.cate_id"
            v-for="cat in form.catList"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务电话" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="平台抽成比例"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="管理员授权个数"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="查看真实号码"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-radio-group v-model="form.radio1">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="邀请业务员"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-radio-group v-model="form.radio1">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="邀请渠道商"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-radio-group v-model="form.radio1">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="经纪人拉技师"
        prop="name"
        :label-width="formLabelWidth"
      >
        <el-radio-group v-model="form.radio1">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading"
        >确 定</el-button
      >
    </div>
    <!--上传图片组件-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :type="type"
      @returnImgs="returnImgsFunc"
      >上传图片</Upload
    >
  </el-dialog>
</template>

<script>
import materialApi from "@/api/material.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload,
  },
  data() {
    return {
      filePath:'',
      form: {
        cate_id: "",
        name: "",
        sort: 100,
        material_stock: "",
        material_price: "",
        sales_actual: 0,
        // imageId: "",
        radio: 1,
        radio1: 1,
        catList: [
          {
            name: "浙江",
            cate_id: 1,
          },
          { name: "上海", cate_id: 2 },
          { name: "北京", cate_id: 3 },
        ],
      },
      formRules: {
        name: [
          {
            required: true,
            message: "请输入物料名称",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "物料排序不能为空",
          },
          {
            type: "number",
            message: "物料排序必须为数字",
          },
        ],
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false,
    };
  },
  props: ["open_add", "addform"],
  created() {
    console.log(this.addform);
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加物料*/
    addUser() {
      let self = this;
      let params = self.form;
      console.log(params);
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          materialApi
            .addProduct(params)
            .then((data) => {
              self.loading = false;
              self.$message({
                message: "添加成功",
                type: "success",
              });
              self.dialogFormVisible(true);
            })
            .catch((error) => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false,
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false,
        });
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.filePath = e[0].filePath;
        this.form.imageId = e[0].fileId;
      }
      this.isupload = false;
    },
  },
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/agent/agent/Add.vue